import React from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import RestaurantLoader from "../utils/RestaurantLoader";

const CatalogSection = (props) => {
  const { darkMode, color } = useSelector((state) => state.global);
  const { catalogLoader } = useSelector((state) => state.restaurants);
  const { catalogs } = props;

  const formatDate = (date) => {
    return new Date(
      date.seconds * 1000 + date.nanoseconds / 1e6
    ).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const convertToAmPm = (timeString) => {
    const [hours, minutes] = timeString.split(":");
    const date = new Date();
    date.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0);
    const amPmTimeString = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    return amPmTimeString;
  };

  return (
    <Container className="categories pt-5">
      <div>
        <h4
          className={
            darkMode
              ? "fs--18 fw--600 normal-heading-dark"
              : "fs--18 fw--600 normal-heading"
          }
        >
          Catalogs
        </h4>
      </div>
      <Row className="p-3">
        {catalogLoader ? (
          <RestaurantLoader message="Fetching Catalogs" />
        ) : (
          <>
            {catalogs?.length > 0 ? (
              <>
                {catalogs?.map((item, index) => {
                  const { startDate, endDate } = item.availabilityDate || {};

                  const formattedStartDate = startDate
                    ? formatDate(startDate)
                    : "";
                  const formattedEndDate = endDate ? formatDate(endDate) : "";

                  const dateRange = `${formattedStartDate} - ${formattedEndDate}`;
                  return (
                    <Col
                      lg="4"
                      md="4"
                      sm="6"
                      xs="12"
                      key={index}
                      className="d-flex justify-content-center mb-4"
                    >
                      <div
                        className="catalog-card p-4 px-3 w-100 text-center d-flex flex-column justify-content-center align-items-center"
                        style={{
                          background: `linear-gradient(135deg, ${color}, #5c5c5c)`,
                          borderRadius: "16px",
                          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
                          minHeight: "150px",
                        }}
                      >
                        <h6 className="text-white fw-bold mb-2 text-uppercase">
                          {item?.category}
                        </h6>

                        {!item?.availabilityDate && (
                          <span className="text-white fw-light">
                            {item?.availability || "Available"}
                          </span>
                        )}

                        {item?.availabilityDate && (
                          <span className="text-white fw-light mb-1">
                            {dateRange}
                          </span>
                        )}

                        <span className="text-white fw-light">
                          {convertToAmPm(item?.startTime)} -{" "}
                          {convertToAmPm(item?.endTime)}
                        </span>
                      </div>
                    </Col>
                  );
                })}
              </>
            ) : (
              <div className="fs--18 fw--100 text-muted w-100 d-flex justify-content-center text-center py-3">
                No Catalog Added Yet
              </div>
            )}
          </>
        )}
      </Row>
    </Container>
  );
};

export default CatalogSection;
